import React from 'react';
import { Chip, Tooltip, type SxProps, type Theme } from '@mui/material';

/**
 * PRX-165 B1: a fill-status chip — the short word, with the gate's sentence
 * as a tooltip when there is one. The tooltip DESCRIBES the chip
 * (`describeChild`), so a screen reader still hears the word, and the chip is
 * focusable so a keyboard user reaches the sentence; the same pattern as
 * Patient 360's Rx Active cell (`RxStatusCell.tsx`). With no tooltip (every
 * Kroll row) it is the plain chip those tables always rendered.
 */
export interface FillStatusChipProps {
  display: { label: string; color: 'success' | 'warning' | 'error' | 'info' | 'default'; tooltip: string | null };
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}

export const FillStatusChip: React.FC<FillStatusChipProps> = ({ display, sx, 'data-testid': testId }) => {
  const chip = (
    <Chip
      label={display.label}
      size="small"
      color={display.color}
      sx={sx}
      data-testid={testId}
      tabIndex={display.tooltip ? 0 : undefined}
    />
  );
  return display.tooltip ? (
    <Tooltip describeChild title={display.tooltip}>
      {chip}
    </Tooltip>
  ) : (
    chip
  );
};
